import { RouteConfig } from "vue-router";

export const RCompanyDetails: RouteConfig = {
  path: "company-details",
  name: "companiesCompanyDetails",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-company-details" */
      "./VCompanyDetails.vue"
    ),
  meta: {
    label: "company-details",
    title: "Companies",
    alias: "summary",
  },
};
